import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";

const useFunilGrupoProdutoMapeamentoInicial = ({ trilhas, gruposMateriais }) => {
  const [funilGrupoProdutoMapeamentoInicial, setFunilGrupoProdutoMapeamentoInicial] = useState([]);

  useEffect(() => {
    const fetchMapeamentoInicial = async () => {
      const gruposObrigatorios = [];
      await db.funilObraGrupoProdutoMapeamentoInicial.each((grupo) => {
        gruposObrigatorios.push(grupo);
      });
      setFunilGrupoProdutoMapeamentoInicial(gruposObrigatorios);
    };

    fetchMapeamentoInicial();
  }, []);

  const mapeamentoInicialTrilhas = useMemo(() => {
    return (funilGrupoProdutoMapeamentoInicial || []).reduce((acc, cur) => {
      acc[cur.trilhaId] ??= {};

      acc[cur.trilhaId][cur.funilObraGrupoProdutoId] ??= {
        required: cur.obrigatorio,
        funilObraGrupoProdutoId: cur.funilObraGrupoProdutoId
      };

      return acc;
    }, {});
  }, [funilGrupoProdutoMapeamentoInicial]);

  return {
    mapeamentoInicialTrilhas,
  };
};

export default useFunilGrupoProdutoMapeamentoInicial;
